import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

const MMFooter = () => {
  const navigate = useNavigate();
  let getYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
  };
  return (
    <div>
      <section className="p-3 bg-mcolor dark:bg-dark">
        <div className="container mx-auto">
          <div className=" bg-mcolor  w-full  p-1 md:flex md:items-center md:justify-between">
            <span className="text-sm text-mwhite font-mfont font-bold sm:text-center  dark:text-gray-400">  © {getYear()} Making Minds Technologies. All Rights Reserved.
            </span>
            <ul className="flex flex-wrap items-center mt-3 text-sm font-medium text-gray-500 dark:text-gray-400 sm:mt-0">
              {/* <li>
        <Link onClick={() =>
          navigate({
            pathname: `${process.env.PUBLIC_URL}/privacypolicy`
          })
        } className="mr-4 hover:underline md:mr-6 ">Privacy Policy</Link>
      </li> */}
              {/* <li>
        <Link onClick={() =>
          navigate({
            pathname: `${process.env.PUBLIC_URL}/termsandcondition`
          })
        } className="mr-4 hover:underline md:mr-6 "> Terms & conditions</Link>
      </li> */}
              <li>
                <Link onClick={() =>
                  navigate({
                    pathname: `${process.env.PUBLIC_URL}/contact`
                  })
                } className="mr-4 hover:underline md:mr-6 font-mfont  hidden">Help</Link>
              </li>
            </ul>
          </div>
        </div>
      </section></div>
  )
}

export default MMFooter